var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 13.46C12.7402 13.46 13.3402 12.8601 13.3402 12.12C13.3402 11.38 12.7402 10.78 12.0002 10.78C11.2601 10.78 10.6602 11.38 10.6602 12.12C10.6602 12.8601 11.2601 13.46 12.0002 13.46Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.44001C12.7402 8.44001 13.3402 7.84007 13.3402 7.10001C13.3402 6.35995 12.7402 5.76001 12.0002 5.76001C11.2601 5.76001 10.6602 6.35995 10.6602 7.10001C10.6602 7.84007 11.2601 8.44001 12.0002 8.44001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 18.47C12.7402 18.47 13.3402 17.8701 13.3402 17.13C13.3402 16.39 12.7402 15.79 12.0002 15.79C11.2601 15.79 10.6602 16.39 10.6602 17.13C10.6602 17.8701 11.2601 18.47 12.0002 18.47Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.676c5b700a9010441672af0f3a265897.svg";
export { ForwardRef as ReactComponent };